import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';
import withWidth from '@material-ui/core/withWidth';

import { Field, getFormValues } from 'redux-form';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import Filter from 'components/common/Filter';
import RadioButtonField from 'components/fields/RadioButtonField';
import RadioGroupField from 'components/fields/RadioGroupField';
import TabNavigation from 'components/common/TabNavigation';
import PrescribersTable from 'components/settings/PrescribersTable';
import PrescriberCreateEditDialog from 'components/settings/PrescriberCreateEditDialog';
import PrescribersSearchDialog from 'components/settings/PrescribersSearchDialog';

import {
  fetchPrescribers,
  clearPrescribers,
} from 'redux/modules/prescribers';

import { getFilterChangeTypes } from 'utils/filterChangeTypes';
import objectDiff from 'utils/objectDiff';
import throttle from 'utils/throttle';

import { appTitle, titleSeparator } from 'config/helmetSettings';

import * as normalize from 'utils/normalize';

class MedicalSourcesPrescribers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchDialogOpen: false,
      createDialogOpen: false,
      createDialogInitialValues: null,
      mobileFilterExpanded: ['xs', 'sm'].indexOf(props.width) === -1,
      limit: 10,
      offset: 0,
    };

    this.onRequest = this.onRequest.bind(this);
    this.onFilterButtonClick = this.onFilterButtonClick.bind(this);
    this.onSearchDialogClose = this.onSearchDialogClose.bind(this);
    this.onPrescriberSelect = this.onPrescriberSelect.bind(this);
    this.onCreateDialogClose = this.onCreateDialogClose.bind(this);
    this.onPrescriberSearchButtonClick = this.onPrescriberSearchButtonClick.bind(this);
    this.onMobileFilterBottonClick = this.onMobileFilterBottonClick.bind(this);
    this.onTableScroll = this.onTableScroll.bind(this);

    this.onThrottledRequest = throttle(this.onRequest, 2000, false, true);
  }

  componentWillMount() {
    this.props.actions.clearPrescribers();
  }

  componentDidMount() {
    this.onRequest();
  }

  componentWillReceiveProps(nextProps) {
    const { filters, width } = this.props;
    const { limit, offset } = this.state;
    const filtersChanged = nextProps.filters['Full Name'] !== filters['Full Name']
      || nextProps.filters['Pecos Status'] !== filters['Pecos Status'];
    let newOffset = offset;
    if (filtersChanged) {
      newOffset = 0;
    }
    if (newOffset !== offset) {
      this.setState({ offset: newOffset });
    }

    if (nextProps.width !== width) {
      this.setState({
        mobileFilterExpanded: ['xs', 'sm'].indexOf(nextProps.width) === -1,
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return ((Object.keys(objectDiff(this.props, nextProps)).length +
      Object.keys(objectDiff(this.state, nextState)).length) > 0);
  }

  componentDidUpdate(prevProps, prevState) {
    const { filters, prescribers, count, loading } = this.props;
    const { limit, offset } = this.state;
    const limitChanged = prevState.limit !== limit;
    const offsetChanged = prevState.offset !== offset;
    const { throttledFiltersChanged, filtersChanged } = getFilterChangeTypes(
      prevProps.filters,
      filters,
      {
        textFilterKeys: ['Full Name'],
        immediateFilterKeys: ['Pecos Status'],
      },
    );

    if (throttledFiltersChanged) {
      this.onThrottledRequest();
    } else if (limitChanged || offsetChanged || filtersChanged) {
      this.onRequest();
    } else if (prescribers.length < count
      && this.scrollRef
      && this.scrollRef.scrollTop === 0
      && loading === 0) {
      this.onTableScroll({ target: this.scrollRef });
    }
  }

  onRequest() {
    const { actions, filters } = this.props;
    const { limit, offset } = this.state;
    const requestFilters = filters && Object.keys(filters).length > 0
      ? Object.keys(filters).map(key => ({
        name: key,
        operation: key === 'Pecos Status' ? 'eq' : 'startswith',
        val: filters[key],
        ...key !== 'Pecos Status' ? { case_sensitivity: false } : {},
      }))
      : null;
    actions.fetchPrescribers({
      limit,
      offset,
      filters: requestFilters,
      triggerLoading: true,
      push: offset > 0,
    });
  }

  onFilterButtonClick() {
    this.setState({ searchDialogOpen: true });
  }

  onSearchDialogClose() {
    this.setState({
      searchDialogOpen: false,
      createDialogInitialValues: null,
    });
  }

  onPrescriberSelect(values) {
    const newState = {
      searchDialogOpen: false,
      createDialogOpen: true,
    };
    if (values) {
      const primaryAddress = values.addresses[0];
      const primaryTaxonomy = values.taxonomies[0];
      let addressPhone = primaryAddress.phone;
      if (!addressPhone) {
        const addressWithPhone = values.addresses.find(item => item.phone);
        if (addressWithPhone) {
          addressPhone = addressWithPhone.phone;
        }
      }
      const phone = addressPhone.indexOf('+1 ') !== -1
        ? addressPhone.replace('+1 ', '') : addressPhone;  
      newState.createDialogInitialValues = {
        'First Name': values.first_name,
        'Last Name': values.last_name,
        NPI: values.npi.toString(),
        LIC: primaryTaxonomy.license,
        Phone: normalize.phone(phone),
        'Name Prefix': values.name_prefix ? values.name_prefix : '',
        'Name Suffix': (values.name_suffix && values.name_suffix !== '--') ? values.name_suffix : '',
        Credential: values.credential ? values.credential : '',
        address: {
          Street: primaryAddress.address,
          City: primaryAddress.city,
          State: primaryAddress.state,
          'Zip Code': primaryAddress.postal_code.slice(0, 5),
        },
        taxonomies: values.taxonomies.map(item => ({
          Code: item.code,
          Description: item.desc,
          'Is Primary': item.primary,
          ...item.state ? { State: item.state } : {},
          ...item.license ? { License: item.license } : {},
        })),
      };
    } else {
      newState.createDialogInitialValues = null;
    }
    this.setState(newState);
  }

  onCreateDialogClose() {
    this.setState({
      createDialogOpen: false,
      createDialogInitialValues: null,
    });
  }

  onPrescriberSearchButtonClick() {
    this.setState({
      createDialogOpen: false,
      searchDialogOpen: true,
    });
  }

  onMobileFilterBottonClick() {
    this.setState({ mobileFilterExpanded: !this.state.mobileFilterExpanded });
  }

  onTableScroll(event) {
    const { offset, limit } = this.state;

    if ((event.target.offsetHeight + event.target.scrollTop) / event.target.scrollHeight > 0.9) {
      if ((this.props.prescribers.length - limit) >= offset) {
        this.setState({
          offset: offset + limit,
        });
      }
    }
  }

  render() {
    const { prescribers, count, loading, filters } = this.props;
    const {
      searchDialogOpen,
      createDialogOpen,
      createDialogInitialValues,
      mobileFilterExpanded,
    } = this.state;
    return (
      <Layout variant="settings">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Prescribers
          </title>
        </Helmet>
        <TabNavigation
          items={[
            {
              text: 'Referrals',
              href: '/settings/medical-sources/referrals',
            },
            {
              text: 'Sales',
              href: '/settings/medical-sources/sales',
            },

            {
              text: 'Prescribers',
              href: '/settings/medical-sources/prescribers',
            },
            {
              text: 'HCPCS Codes',
              href: '/settings/medical-sources/hcpc',
            },
            {
              text: 'Diagnosis',
              href: '/settings/medical-sources/diagnosis',
            },
            {
              text: 'Payers',
              href: '/settings/medical-sources/payers',
            },
          ]}
        />
        <Filter
          form="prescribersFilter"
          placeholder="Search Prescriber"
          primaryButtonText="Add New"
          onPrimaryButtonClick={this.onFilterButtonClick}
          onMobileFilterBottonClick={this.onMobileFilterBottonClick}
          mobileFilterExpanded={mobileFilterExpanded}
          filters={filters}
          showTableCount
          count={count}
          loading={loading}
          items={prescribers}
          searchWidth={5}
          secondaryFilter={(
            <Grid item>
              <Paper>
                <FormControl role="group">
                  <Field
                    name="Pecos Status"
                    component={RadioGroupField}
                  >
                    {['All', 'Active', 'Inactive', 'Invalid'].map(item => (
                      <RadioButtonField
                        key={item}
                        value={item}
                        label={item}
                        color="primary"
                      />
                    ))}
                  </Field>
                </FormControl>
              </Paper>
            </Grid>
          )}
          initialValues={{ 'Pecos Status': 'All' }}
          beforeTable
        />
        {loading > 0 &&
          <Progress fixed />
        }
        <PrescribersTable
          items={prescribers}
          count={count}
          loading={loading}
          mobileFilterExpanded={mobileFilterExpanded}
          onScroll={this.onTableScroll}
          scrollRef={(scrollRef) => { this.scrollRef = scrollRef; }}
        />
        <PrescriberCreateEditDialog
          form="prescriberCreate"
          open={createDialogOpen}
          onClose={this.onCreateDialogClose}
          onSubmitSuccess={() => this.onRequest()}
          {...createDialogInitialValues ? {
            initialValues: createDialogInitialValues,
          } : {}}
          onSearchButtonClick={this.onPrescriberSearchButtonClick}
        />
        <PrescribersSearchDialog
          form="prescribersCreateRegistrySearch"
          open={searchDialogOpen}
          clearOnOpen={!createDialogInitialValues}
          onClose={this.onSearchDialogClose}
          onPrescriberSelect={this.onPrescriberSelect}
        />
      </Layout>
    );
  }
}

MedicalSourcesPrescribers.propTypes = {
  prescribers: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  count: PropTypes.number.isRequired,
  loading: PropTypes.number.isRequired,
  filters: PropTypes.shape({
    'Full Name': PropTypes.string,
  }).isRequired,
  actions: PropTypes.shape({
    fetchPrescribers: PropTypes.func.isRequired,
    clearPrescribers: PropTypes.func.isRequired,
  }).isRequired,
  width: PropTypes.string.isRequired,
};

MedicalSourcesPrescribers.defaultProps = {};

const mapStateToProps = (store) => {
  const prescribersFilterValues = getFormValues('prescribersFilter')(store);
  return {
    prescribers: store.prescribers.data,
    count: store.prescribers.count,
    filters: {
      ...prescribersFilterValues
        && prescribersFilterValues.Filter
        ? { 'Full Name': prescribersFilterValues.Filter }
        : {},
      ...prescribersFilterValues
        && prescribersFilterValues['Pecos Status']
        && prescribersFilterValues['Pecos Status'] !== 'All'
        ? { 'Pecos Status': prescribersFilterValues['Pecos Status'] }
        : {},
    },
    loading: store.prescribers.loading,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchPrescribers,
    clearPrescribers,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withWidth()(MedicalSourcesPrescribers),
);



// WEBPACK FOOTER //
// ./src/pages/settings/MedicalSourcesPrescribers.js